define('modules/reporting/campaigns/reachFrequency/views/columnSelector',["T1ColumnSortable"], function (ColumnSortable) {
  "use strict";

  var rfColumnSelector = ColumnSortable.extend({});
  return rfColumnSelector;
});
